import { render, staticRenderFns } from "./DocumentViewCard3.vue?vue&type=template&id=607b7dd9"
import script from "./DocumentViewCard3.vue?vue&type=script&lang=js"
export * from "./DocumentViewCard3.vue?vue&type=script&lang=js"
import style0 from "./DocumentViewCard3.vue?vue&type=style&index=0&id=607b7dd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports